var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { useLucidSdk } from '#context';
import { CapabilitiesKeyFactory } from '../../query-key-factories';
import { canFetchWorkspaceData } from '../../services';
import { useCurrentMemberByWorkspaceId } from './useCurrentMemberByWorkspaceId';
import { useGetWorkspaceLoginStatus } from './useGetWorkspaceLoginStatus';
export const useGetMembersCapabilities = ({ workspaceId, }) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const { query: { data: workspaceLoginStatus }, } = useGetWorkspaceLoginStatus(workspaceId);
    const { query: { data }, } = useCurrentMemberByWorkspaceId(workspaceId);
    const isQueryEnabled = Boolean(data?.privileges?.membersRead) &&
        canFetchWorkspaceData(workspaceLoginStatus);
    const query = useQuery({
        queryFn: () => lucidSdk
            .workspaceClient(workspaceId)
            .billing()
            .getMembersCapabilities(),
        queryKey: CapabilitiesKeyFactory.membersCapabilities(workspaceId),
        enabled: isQueryEnabled,
        networkMode: 'always',
        retry: false,
    });
    return { query };
};
_react_refresh_temp_1(useGetMembersCapabilities, "r2PDOlocD/irf1Dv5iibEUrLvDA=", false, () => [useLucidSdk, useGetWorkspaceLoginStatus, useCurrentMemberByWorkspaceId, useQuery]);
